import React from 'react';
import { Header } from './components/Header';
import { FactoryShowcase } from './components/FactoryShowcase';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Collection } from './components/Collection';
import { SalesProduct } from './components/SalesProduct';
import { PricingTable } from './components/PricingTable';
import { Feedback } from './components/Feedback';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-[#7E3007]/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Header data-id="element-2" />
      <main data-id="element-3">
        <FactoryShowcase data-id="element-4" />
        <WhyChooseUs data-id="element-5" />
        <Collection data-id="element-6" />
        <SalesProduct data-id="element-7" />
        <PricingTable data-id="element-8" />
        <Feedback data-id="element-9" />
        <ContactForm data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
      <FloatingWhatsApp data-id="element-12" />
    </div>;
}